<template>
  <li
    class="option-template-user"
    :class="{
      'single': singleSelect,
      'focused': isFocused
    }"
    @click="optionSelected"
  >
    <profile-avatar
      :size="(selectionHeight >> 2) + (selectionHeight >> 1)"
      :username="optionData['FullName']"
      :style="'margin: ' + (selectionHeight >> 3) + 'px;'"
    />

    <div class="user-details">
      <p>{{ displayText }}</p>
      <p id="subtitle">
        {{ optionData[settings.subtitleKey] }}
      </p>
    </div>

    <checkbox-input
      class="checkbox-class"
      v-if="!singleSelect"
      :value="optionData.selected"
    />
  </li>
</template>

<script>
  import CheckboxInput from '../../checkbox/CheckboxInput'

  export default {
    name: 'OptionTemplateUser',
    components: {
      'checkbox-input': CheckboxInput
    },
    props: {
      optionData: {
        default: function () {
          return {}
        },
        type: Object
      },
      settings: {
        default: function () {
          return {
            subtitleKey: 'Email',
            displayKey: 'Name',
            tall: true,
            singleSelect: false
          }
        },
        type: Object
      }
    },
    methods: {
      optionSelected () {
        let self = this
        self.$emit('optionSelected', self.optionData)
      }
    },
    computed: {
      isFocused () {
        let self = this
        let result = self.optionData.isFocusedOption
        return result
      },
      subtitle () {
        let self = this
        let result = self.optionData[self.settings.subtitleKey]
        return result
      },
      displayKey () {
        let self = this
        let result = self.settings.displayKey
        return result
      },
      displayText () {
        let self = this
        let result = self.optionData[self.displayKey]
        return result
      },
      tall () {
        let self = this
        let result = self.settings.tall
        return result
      },
      singleSelect () {
        let self = this
        let result = self.settings.singleSelect
        return result
      },
      selectionHeight () {
        return this.tall ? 50 : 28
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import '../../../uikit';

  .option-template-user {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    * {
      vertical-align: middle;
    }

    .profile-avatar {
      display: inline-block;
      vertical-align: middle;
    }

    .user-details {
      display: inline-block;
      vertical-align: middle;
      width: calc(100% - 100px);
      padding: 0 5px;

      p {
        margin: 0;
        max-width: calc(100% - 10px);
        max-height: 20px;
        text-overflow: ellipsis;
        overflow: hidden
      }

      #subtitle {
        color: $secondaryBorderColor;
      }
    }

    .checkbox-class {
      display: inline-block;
      line-height: 16px;
      pointer-events: none;
    }

    &.single {
      list-style: none;
      padding: 0;

      .user-details {
        width: calc(100% - 53px);

        @supports (-moz-appearance:none) {
          width: calc(100% - 53px);
        }

        @supports (-ms-ime-align:auto) {
          width: calc(100% - 100px);
        }
      }
    }

    &:hover {
      background: $lightGreyBackground;
    }

    &.focused {
      background: $mediumGreyBackground;
    }
  }

</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/sns-components/kit-components/input-templates/selection/option-templates/OptionTemplateUser.vue